export const USER_CREATED = 1;
export const USER_UNDER_VALIDATION = 2;
export const USER_VALIDATED = 3;
export const USER_INVALID = 4;
